import { Injectable, inject } from '@angular/core';
import { WIFI_PORTAL_NO_SQA_MESSAGE } from '../../constants/login-constant';
import { LoginModalContent } from '../../models/aem';
import { WifiPortalService } from '../../services/wifi-portal/wifi-portal.service';

@Injectable({
  providedIn: 'root'
})
export class RecoverYourAccountAdapterService {
  wifiPortalService = inject(WifiPortalService);

  getRecoverYourAccountScreenContent(loginModalContent: LoginModalContent) {
    const { recoverAccount, pageHeader, commonOverlayMessages } =
      loginModalContent;

    const pageHeaderObj = {
      logoUrl: pageHeader.logoUrl,
      altText: pageHeader.altText
    };

    recoverAccount.message.emailExpired = commonOverlayMessages.emailExpired;

    return {
      ...pageHeaderObj,
      ...recoverAccount,
      wifiPortal: this.wifiPortalService.getQueryParamsWFP().isWFP,
      message: {
        ...recoverAccount.message,
        wfp: this.wifiPortalService.lockSQA
          ? recoverAccount.message.wfp
          : WIFI_PORTAL_NO_SQA_MESSAGE
      }
    };
  }
}
